import { render, staticRenderFns } from "./NewRxSlideOver.vue?vue&type=template&id=11945720"
import script from "./NewRxSlideOver.vue?vue&type=script&lang=js"
export * from "./NewRxSlideOver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports